import DmpClaim from '../models/dmpClaim';

export default class {
    constructor(booking) {
        this.booking = booking;
        this.dmpBalance = {};
        this.dmpClaim = new DmpClaim();
        this.updating = false;
        this.hasBalance = false;

        // Set available DMP balance initially.
        this.updateDmpBalance();
    }

    /**
     * Fetch the current balance from API.
     * @return {Void}
     */
    updateDmpBalance() {
        this.updating = true;
        this.booking.$api.gms.member.getDmpBalance()
        .then((response) => {
            this.updating = false;
            if (!response.data.success) {
                throw response.data;
            }
            this.dmpBalance = response.data.result;

            this.hasBalance = true;
            if (this.dmpBalance.corporateDmp == 0 && this.dmpBalance.partnerDmp == 0 && this.dmpBalance.privateDmp == 0 && _.isEmpty(this.dmpBalance.parentDmps)) {
                this.hasBalance = false;
            }

            // Create parent claims array.
            for (let i = 0; i < this.dmpBalance.parentDmps.length; i++) {
                if (!this.dmpClaim.parentClaims[i]) {
                    this.dmpClaim.parentClaims[i] = {
                        parentUuid: this.dmpBalance.parentDmps[i].uuid,
                        parentDmp: 0,
                    };
                }
            }
        })
        .catch((error) => {
            this.updating = false;
        });
    }

    claimDmp() {
        this.updating = true;
        this.booking.$api.gms.reservation.claimDmp(this.booking.gms.visitId, this.dmpClaim)
        .then((response) => {
            // Refresh visit data on success.
            this.booking.$api.gms.reservation.findVisit(this.booking.gms.visitId)
            // eslint-disable-next-line no-shadow
            .then((response) => {
                this.booking.gms.visit = response;
                this.updateDmpBalance();
            })
            .catch((error) => {});
        })
        .catch((error) => {
            // Reset claims on error.
            this.dmpClaim = new DmpClaim();
            for (let i = 0; i < this.dmpBalance.parentDmps.length; i++) {
                this.dmpClaim.parentClaims[i] = {
                    parentUuid: this.dmpBalance.parentDmps[i].uuid,
                    parentDmp: 0,
                };
            }
            this.claimDmp();
        });
    }

    getDaymembersWithoutDmp() {
        const result = [];

        for (let index = 0; index < this.booking.gms.visit.flights.length; index++) {
            const flight = this.booking.gms.visit.flights[index];

            // eslint-disable-next-line no-shadow
            for (let index = 0; index < flight.members.length; index++) {
                const player = flight.members[index];

                if (!player.uuid && !player.youndAdult && !player.usesDmp) {
                    result.push(player);
                }
            }
        }

        return result;
    }

    usableDmps(available, spent) {
        const daymembers = this.getDaymembersWithoutDmp();

        if (daymembers.length >= available + spent) {
            return available + spent;
        }

        if (daymembers.length <= spent) {
            return Math.min(daymembers.length + spent, available + spent);
        }

        return daymembers.length;
    }
}
